import {BullhornEntityType} from '../types/bullhorn/bullhorn-entity-type';

export const DEFAULT_BULLHORN_PROMPT_FIELDS: Map<BullhornEntityType, string[]> = new Map([
  [BullhornEntityType.CANDIDATE,
    [
      'Candidate.id',
      'Candidate.firstName',
      'Candidate.lastName',
      'Candidate.description'
    ],
  ],
  [
    BullhornEntityType.JOB_ORDER,
    [
      'JobOrder.id',
      'JobOrder.title',
      'JobOrder.description',
      'JobOrder.clientCorporation.id',
      'JobOrder.clientCorporation.name',
      'JobOrder.clientCorporation.companyDescription',
      'JobOrder.clientContact.id',
      'JobOrder.dateAdded',
      'JobOrder.status',
    ],
  ],
  [
    BullhornEntityType.CLIENT_CONTACT,
    [
      'ClientContact.id',
      'ClientContact.firstName',
      'ClientContact.lastName',
      'ClientContact.clientCorporation.id',
      'ClientContact.clientCorporation.name',
      'ClientContact.clientCorporation.companyDescription',
    ],
  ],
  [
    BullhornEntityType.JOB_SUBMISSION,
    [
      'Candidate.name',
      'Candidate.firstName',
      'Candidate.lastName',
      'Candidate.description',
      'JobOrder.description',
      'JobOrder.clientCorporation.id',
      'JobOrder.clientCorporation.name',
      'JobOrder.clientCorporation.companyDescription',
    ],
  ],
  [
    BullhornEntityType.OPPORTUNITY,
    [
      'Opportunity.title',
      'Opportunity.clientCorporation',
      'Opportunity.type',
      'Opportunity.status',
      'Opportunity.description'
    ],
  ],
  [
    BullhornEntityType.LEAD,
    [
      'Lead.firstName',
      'Lead.lastName',
      'Lead.companyName',
      'Lead.type',
      'Lead.comments',
    ],
  ],
  [
    BullhornEntityType.PLACEMENT,
    [
      'Placement.employmentType',
      'Placement.dateBegin',
      'Placement.dateEnd',
      'Placement.costCenter',
      'Placement.employeeType',
      'Placement.salary',
      'Placement.fee'
    ],
  ],
  [
    BullhornEntityType.CLIENT_CORPORATION,
    [
      'ClientCorporation.name',
      'ClientCorporation.parentClientCorporation',
      'ClientCorporation.companyDescription',
      'ClientCorporation.companyURL',
      'ClientCorporation.address'
    ],
  ],
  [
    BullhornEntityType.NOTE,
    [
      'Note.comments'
    ],
  ]
]);
